import { useMoment } from '@hooks';
import { Notification } from '@services';
import { BiInfoCircle } from 'react-icons/bi';
import { BsMegaphoneFill } from 'react-icons/bs';
import { HiNewspaper } from 'react-icons/hi2';
import { IoDocumentText } from 'react-icons/io5';

export const useNotificationCard = (notification: Notification) => {
    const { formatAgo } = useMoment();

    const getIcon = () => {
        switch (notification.type) {
            case 'document':
                return <IoDocumentText />;
            case 'push':
                return <BsMegaphoneFill />;
            case 'news':
                return <HiNewspaper />;
            default:
                return <BiInfoCircle />;
        }
    };

    const getTypeLabel = () => {
        switch (notification.type) {
            case 'news':
                return 'Actualité';
            case 'push':
                return 'Alerte';
            case 'document':
                return 'Documents';
            default:
                return 'Notification';
        }
    };

    return {
        getIcon,
        getTypeLabel,
        formatAgo
    };
};
